import { payoutPercent } from '../lib/format.js';
import { haptic } from '../lib/telegram.js';
import type { PairOption } from './PairSheet.js';
import { SheetPortal } from './SheetPortal.js';

/**
 * Шторка выбора НЕСКОЛЬКИХ пар галочками — для стратегии «Кастом».
 * Отличие от `PairSheet`: тап переключает галочку, а не закрывает шторку;
 * список уходит на сервер кнопкой «Готово» одним запросом.
 */
export function PairPickSheet({
  assets,
  selected,
  max,
  onToggle,
  onClear,
  onClose,
  t,
}: {
  assets: PairOption[];
  selected: string[];
  max: number;
  onToggle: (symbol: string) => void;
  onClear: () => void;
  onClose: () => void;
  t: (key: string, params?: Record<string, string | number>) => string;
}) {
  // отмеченные сверху, дальше — по выплате (порядок сервера)
  const ordered = [
    ...assets.filter((asset) => selected.includes(asset.symbol)),
    ...assets.filter((asset) => !selected.includes(asset.symbol)),
  ];

  return (
    <SheetPortal>
      <div
        className="sheet-backdrop"
        onClick={(event) => {
          if (event.target === event.currentTarget) onClose();
        }}
      >
        <div className="sheet">
          <div className="sheet-handle" />
          <span className="kicker">{t('custom.param.pairs')}</span>
          <h2 className="sheet-title-grad">{t('app.trade.custom_pairs_pick')}</h2>
          <p className="body pair-sheet-hint">
            {t('app.trade.custom_pairs_hint')} · {selected.length}/{max}
          </p>

          <div className="info-list">
            {ordered.map((asset) => {
              const on = selected.includes(asset.symbol);
              return (
                <button
                  key={asset.symbol}
                  type="button"
                  className={`info-row pair-row ${on ? 'is-selected' : ''}`}
                  onClick={() => {
                    haptic();
                    onToggle(asset.symbol);
                  }}
                >
                  <span className={`pair-check ${on ? 'is-on' : ''}`}>{on ? '✓' : ''}</span>
                  <span className="grow chip-label">{asset.label ?? asset.symbol}</span>
                  {asset.payout !== null && asset.payout !== undefined && (
                    <span className="chip-payout">{payoutPercent(asset.payout)}%</span>
                  )}
                </button>
              );
            })}
          </div>

          <div className="row" style={{ marginTop: 14 }}>
            <button type="button" className="cta cta-secondary grow" onClick={onClear}>
              {t('custom.pairs_auto')}
            </button>
            <button type="button" className="cta grow" onClick={onClose}>
              {t('button.custom.done')}
            </button>
          </div>
        </div>
      </div>
    </SheetPortal>
  );
}
